module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', {
    attrs: {
      "nav": ""
    }
  }, [_vm._l((_vm.singleMenus), function(menu, i) {
    return _c('div', {
      key: i,
      staticClass: "mb-3"
    }, [(!menu.subMenus) ? _c('v-list-item', {
      attrs: {
        "active-class": "ims-nav-active",
        "to": menu.link
      }
    }, [_c('v-list-item-icon', [_c('v-icon', {
      domProps: {
        "textContent": _vm._s(menu.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-item-title', {
      domProps: {
        "textContent": _vm._s(menu.name)
      }
    })], 1) : _vm._e(), _vm._v(" "), (menu.subMenus) ? _c('v-list-group', {
      class: {
        'ims-nav-group-active': _vm.isMenuRouteActive(menu)
      },
      attrs: {
        "prepend-icon": menu.icon,
        "no-action": "",
        "active-class": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(menu.name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((menu.subMenus), function(smenu, i) {
      return _c('v-list-item', {
        key: i,
        attrs: {
          "exact": "",
          "to": smenu.link,
          "active-class": "ims-nav-active"
        }
      }, [_c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(smenu.name)
        }
      }), _vm._v(" "), _c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(smenu.icon)
        }
      })], 1)], 1)
    })], 2) : _vm._e()], 1)
  }), _vm._v(" "), (_vm.isNotClientRole) ? _c('div', [_c('v-divider'), _vm._v(" "), _vm._l((_vm.groupMenus), function(gmenu) {
    return _c('v-list-group', {
      key: gmenu.name,
      class: [("menu-" + (gmenu.name) + "-group"), {
        'ims-nav-group-active': _vm.isMenuRouteActive(gmenu)
      }],
      attrs: {
        "prepend-icon": gmenu.icon,
        "no-action": "",
        "active-class": ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function() {
          return [_c('v-list-item-title', [_vm._v(_vm._s(gmenu.name))])]
        },
        proxy: true
      }], null, true)
    }, [_vm._v(" "), _vm._l((gmenu.subMenus), function(smenu, i) {
      return _c('v-list-item', {
        key: i,
        attrs: {
          "exact": "",
          "to": smenu.link,
          "active-class": "ims-nav-active"
        }
      }, [_c('v-list-item-title', {
        domProps: {
          "textContent": _vm._s(smenu.name)
        }
      }), _vm._v(" "), _c('v-list-item-icon', [_c('v-icon', {
        domProps: {
          "textContent": _vm._s(smenu.icon)
        }
      })], 1)], 1)
    })], 2)
  })], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48902f42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/DrawerNavList.vue
// module id = 2105
// module chunks = 0